'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
const Hreflang = ({
  href,
  lang
}) => {
  return /*#__PURE__*/_jsx("link", {
    rel: "alternate",
    hrefLang: lang,
    href: href
  });
};
export default Hreflang;